/**
 * Tables Routes
 */
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {AsyncTemplateCreateComponent, AsyncTemplateEditComponent, AsyncTemplatesListComponent} from '../components/AsyncComponent/AsyncComponent';
import {useTranslation} from 'react-i18next';
import {config} from '../config';

const Templates: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className='content-wrapper'>
            <Helmet>
                <title>{`${config.app.name} - ${translate('templates.name')}`}</title>
                <meta name='description' content='Templates' />
            </Helmet>
            <Switch>
                <Route exact path={`${match?.url}`} component={AsyncTemplatesListComponent} />
                <Route exact path={`${match?.url}/create`} component={AsyncTemplateCreateComponent} />
                <Route exact path={`${match?.url}/:id`} component={AsyncTemplateEditComponent} />
                <Redirect exact from={`${match?.url}/`} to={`${match?.url}`} />
            </Switch>
        </div>
    );
};

export default Templates;
